export default "__VITE_ASSET__536c9f78__"